import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IItemLookupTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/item-lookup-tile-definition.interface';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-item-lookup-setup-wizard',
  template: `
    <div class="item-lookup-setup-wizard">
      <h3>Settings</h3>
      <p>This tile has no configurable settings.</p>
    </div>
  `,
  styles: [
    `
      .item-lookup-setup-wizard {
        padding: 16px;
      }

      .item-lookup-setup-wizard h3 {
        margin: 0 0 8px;
      }

      .item-lookup-setup-wizard p {
        margin: 0;
        color: #5c6478;
        line-height: 1.5;
      }
    `,
  ],
})
export class ItemLookupSetupWizardComponent extends TileSetupWizardComponent<IItemLookupTileDefinition> {
  override setupForm = new FormGroup({});
}